import React from 'react';
import {
  Button,
  Tabs,
  Tab,
  Popover,
  Checkbox,
  FormGroup,
  ControlLabel,
  FormControl,
  Radio
} from 'react-bootstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import 'react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';
import _ from 'lodash';

const CreateCheckboxes = (group, groupLabel, filterHousing, filters) => {
  let groupContent = '';
  let leftGroupContent = '';
  let rightGroupContent = '';
  group.forEach((item, key) => {
    if (key < Math.ceil(group.length / 2)) {
      groupContent = (
        <Checkbox
          value='true'
          label={item['value']}
          checked={filters[item['key']] || ''}
          onChange={(evt) => {
            filterHousing(evt.target.checked, item['key']);
          }}
          key={item['key']}
        >
          {item['value']}
        </Checkbox>
      );
      leftGroupContent = [leftGroupContent, groupContent];
    } else {
      groupContent = (
        <Checkbox
          value='true'
          label={item['value']}
          checked={filters[item['key']] || ''}
          onChange={(evt) => {
            filterHousing(evt.target.checked, item['key']);
          }}
          key={item['key']}
        >
          {item['value']}
        </Checkbox>
      );
      rightGroupContent = [rightGroupContent, groupContent];
    }
  });
  return (
    <FormGroup controlId={groupLabel}>
      <ControlLabel>{_.capitalize(groupLabel)}</ControlLabel>
      <section className={'container' + _.capitalize(groupLabel)}>
        <div className={'leftGrp' + _.capitalize(groupLabel)}>
          {leftGroupContent}
        </div>
        <div className={'rightGrp' + _.capitalize(groupLabel)}>
          {rightGroupContent}
        </div>
      </section>
    </FormGroup>
  );
};

const FilterGroups = (props) => {
  if (props.group.length) {
    return CreateCheckboxes(
      props.group,
      props.groupLabel,
      props.filterHousing,
      props.filters
    );
  } else {
    return '';
  }
};

const FilterPopover = (props) => {
  return (
    <Popover
      id='popover-positioned-bottom'
      title='Filters'
      placement='bottom'
      anchorReference={'none'}
      className='popoverRoot'
    >
      <form
        onSubmit={(evt) => {
          evt.preventDefault();
        }}
      >
        <Tabs defaultActiveKey='basic' id='parent-tabs'>
          <Tab eventKey='basic' title='Basic'>
            <FormGroup controlId='maxRent'>
              <ControlLabel>Maximum rent</ControlLabel>
              <FormControl
                type='text'
                placeholder='Enter max rent'
                value={props.filters.rent}
                onChange={(evt) => {
                  props.filterHousing(evt.target.value, 'rent');
                }}
              />
              <FormControl.Feedback />
              {/*<HelpBlock>Validation is based on string length.</HelpBlock>*/}
            </FormGroup>
            <FormGroup controlId='unitType'>
              <ControlLabel>Housing type</ControlLabel>
              <FormControl
                componentClass='select'
                placeholder='Choose'
                value={props.filters.unitTypeTitle}
                onChange={(evt) => {
                  props.filterHousing(evt.target.value, 'unitTypeTitle');
                }}
              >
                <option value=''>Choose</option>
                {props.unitTypes.map((item) => (
                  <option value={item}>{item}</option>
                ))}
              </FormControl>
            </FormGroup>
            <FormGroup controlId='numRooms'>
              <ControlLabel>Number of rooms</ControlLabel>
              <FormControl
                componentClass='select'
                placeholder='Choose'
                value={props.filters.bedroomCount}
                onChange={(evt) => {
                  props.filterHousing(evt.target.value, 'bedroomCount');
                }}
              >
                <option value=''>Choose</option>
                {props.numOfRooms.map((item) => (
                  <option value={item}>{item}</option>
                ))}
              </FormControl>
            </FormGroup>
            <FormGroup controlId='locationGroups'>
              <ControlLabel>Property Name</ControlLabel>
              <FormControl
                componentClass='select'
                placeholder='Choose'
                value={props.filters.locationGroupTitle}
                onChange={(evt) => {
                  props.filterHousing(evt.target.value, 'locationGroupTitle');
                }}
              >
                <option value=''>Choose</option>
                {props.locationGroups.map((item) => (
                  <option value={item}>{item}</option>
                ))}
              </FormControl>
            </FormGroup>
            <FormGroup controlId='date'>
              <ControlLabel>Desired Move in Date</ControlLabel>
              <br />
              <DayPickerInput
                format='MM/DD/YYYY'
                formatDate={formatDate}
                parseDate={parseDate}
                placeholder='MM/DD/YYYY'
                value={props.filters.availableDate}
                inputProps={{ className: 'form-control' }}
                onDayChange={(day) =>
                  props.filterHousing(
                    moment(day).format('MM/DD/YYYY'),
                    'availableDate'
                  )
                }
              />
              <FormControl.Feedback />
            </FormGroup>
          </Tab>
          <Tab eventKey='advanced' title='Advanced'>
            <FormGroup controlId='distance'>
              <ControlLabel>Distance</ControlLabel>
              <FormControl
                type='text'
                placeholder='Distance'
                value={props.filters.distanceFromCampus}
                onChange={(evt) => {
                  props.filterHousing(evt.target.value, 'distanceFromCampus');
                }}
              />
              <FormControl.Feedback />
              <FormGroup controlId={'distance'} className='distance-grp'>
                <ControlLabel>Distance in: </ControlLabel>
                <section className={'containerDistance'}>
                  <div className={'leftDistance'}>
                    <Radio
                      value='miles'
                      label='miles'
                      name='milekm'
                      checked={props.distanceType === 'mile'}
                      onChange={(evt) => {
                        props.setDistanceType('mile');
                      }}
                      key='miles'
                    >
                      Miles
                    </Radio>
                  </div>
                  <div className={'rightDistance'}>
                    <Radio
                      value='km'
                      label='km'
                      name='milekm'
                      checked={props.distanceType === 'km'}
                      onChange={(evt) => {
                        props.setDistanceType('km');
                      }}
                      key='km'
                    >
                      Kilometers
                    </Radio>
                  </div>
                </section>
              </FormGroup>

              {/*<HelpBlock>Validation is based on string length.</HelpBlock>*/}
            </FormGroup>
            <FormGroup controlId='leasetype'>
              <ControlLabel>Lease type</ControlLabel>
              <FormControl
                componentClass='select'
                placeholder='Choose'
                value={props.filters.leaseTypeTitle}
                onChange={(evt) => {
                  props.filterHousing(evt.target.value, 'leaseTypeTitle');
                }}
              >
                <option value=''>Choose</option>
                {props.leaseTermTypes.map((item) => (
                  <option value={item}>{item}</option>
                ))}
              </FormControl>
            </FormGroup>
            <Tabs defaultActiveKey='amenities' id='child-tabs'>
              <Tab
                eventKey='amenities'
                title='Amenities'
                disabled={props.dynamicAmenities.length === 0}
              >
                <FilterGroups
                  group={props.dynamicAmenities}
                  groupLabel='amenities'
                  filterHousing={props.filterHousing}
                  filters={props.filters}
                />
              </Tab>
              <Tab
                eventKey='utilities'
                title='Utilities'
                disabled={props.utilities.length === 0}
              >
                <FilterGroups
                  group={props.dynamicUtilities}
                  groupLabel='utilities'
                  filterHousing={props.filterHousing}
                  filters={props.filters}
                />
              </Tab>
              <Tab
                eventKey='roomates'
                title='Roommates'
                disabled={props.roommates.length === 0}
              >
                <FilterGroups
                  group={props.dynamicRoommateAttributes}
                  groupLabel='roommates'
                  filterHousing={props.filterHousing}
                  filters={props.filters}
                />
              </Tab>
            </Tabs>
          </Tab>
        </Tabs>
      </form>
      <Button
        bsStyle='danger'
        onClick={(evt) => {
          evt.preventDefault();
          props.resetFilters();
        }}
      >
        Clear filters
      </Button>{' '}
      <Button bsStyle='info' onClick={() => document.body.click()}>
        View Results
      </Button>
    </Popover>
  );
};

export default FilterPopover;
